export enum EActivePlayer {
	None,
	P1, // circle
	P2, // cross
}
